import api from "./api";
import { isSubLoginUser } from "../utils/canManageSubLogins";

const SCOPE_FORBIDDEN_MESSAGE_KEY = "@7Cantos:scopeForbiddenMessage";

type GuardHandlers = {
  onUnauthorizedSubLogin: () => void;
  onForbiddenSubLogin: (message: string) => void;
};

function readStoredUser(): { is_sub_login?: boolean } | null {
  try {
    const raw = localStorage.getItem("@7Cantos:user");
    if (!raw || raw === "undefined" || raw === "null") {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function consumeScopeForbiddenMessage(): string | null {
  const message = sessionStorage.getItem(SCOPE_FORBIDDEN_MESSAGE_KEY);
  if (message) {
    sessionStorage.removeItem(SCOPE_FORBIDDEN_MESSAGE_KEY);
  }
  return message;
}

export function setupOwnerSubLoginApiGuards(handlers: GuardHandlers): () => void {
  const interceptorId = api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const user = readStoredUser();

      if (!isSubLoginUser(user)) {
        return Promise.reject(error);
      }

      if (status === 401) {
        handlers.onUnauthorizedSubLogin();
        return Promise.reject(error);
      }

      if (status === 403) {
        const apiMessage =
          typeof error?.response?.data?.message === "string"
            ? error.response.data.message
            : "Você não tem permissão para acessar este recurso.";
        sessionStorage.setItem(SCOPE_FORBIDDEN_MESSAGE_KEY, apiMessage);
        handlers.onForbiddenSubLogin(apiMessage);
      }

      return Promise.reject(error);
    }
  );

  return () => {
    api.interceptors.response.eject(interceptorId);
  };
}
